import { extractNumber } from '@cred/shared/utils'
import { currency } from '@cred/shared/formatters'

// eslint-disable-next-line import/prefer-default-export
export const minMaxLoanAmount = (allLenders) => (value) => {
  const numberValue = extractNumber(value)
  const allMinValues = allLenders.map(({ minLoanAmount }) => minLoanAmount)
  const minValue = Math.min(...allMinValues)
  let error

  if (numberValue < minValue) {
    error = `Please enter at least ${currency(minValue)}`
  }

  return error
}
